import {useCallback, useEffect} from 'react';

import TagManager from 'react-gtm-module';
import {useLocation} from 'react-router-dom';

import {useTrackingManager} from '@/hooks';
import {isLocalhost} from '@/utils/environment';

const GTMPageViewTracker = () => {
  const location = useLocation();
  const {trackNavigation} = useTrackingManager();

  const trackTagManagerDataLayer = useCallback(() => {
    if (isLocalhost) return;

    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        page: location.pathname + location.search,
      },
    });
  }, [location.pathname, location.search]);

  const trackNavigationPath = useCallback(() => {
    if (isLocalhost) return;
    trackNavigation(location.pathname);
  }, [location.pathname, trackNavigation]);

  useEffect(() => {
    trackTagManagerDataLayer();
    trackNavigationPath();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return null;
};

export default GTMPageViewTracker;
